(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social"] && !Shopify.designMode) return;
  try {
    // Language translations
        const translations = {
            en: {
                languageToggle: 'اللغة العربية',
                brandName: 'Little Moments',
                tagline: 'Tiny Hands, Tiny Feet, Timeless Keepsakes',
                whatsapp: 'WhatsApp',
                instagram: 'Instagram',
                tiktok: 'TikTok',
                snapchat: 'Snapchat',
                facebook: 'Facebook',
                scanQRCode: 'Scan QR Code',
                package: 'View Packages'
            },
            ar: {
                languageToggle: 'English',
                brandName: 'لحظات صغيرة',
                tagline: 'أيدي صغيرة، أقدام صغيرة، ذكريات خالدة',
                whatsapp: 'واتساب',
                instagram: 'انستجرام',
                tiktok: 'تيك توك',
                snapchat: 'سناب شات',
                facebook: 'فيسبوك',
                scanQRCode: 'مسح رمز QR',
                package:'عرض الحزم'
            }
        };

        // Current language state
        let currentLanguage = 'en';

        // DOM Elements
        const languageToggle = document.getElementById('languageToggle');
        const linkTreeContainer = document.getElementById('linkTreeContainer');
        const brandTitle = document.getElementById('brandTitle');
        const brandTagline = document.getElementById('brandTagline');
        const whatsappText = document.getElementById('whatsappText');
        const instagramText = document.getElementById('instagramText');
        const tiktokText = document.getElementById('tiktokText');
        const snapchatText = document.getElementById('snapchatText');
        const facebookText = document.getElementById('facebookText');
        const qrCodeSmall = document.getElementById('qrCodeSmall');
        const qrModal = document.getElementById('qrModal');
        const qrModalClose = document.getElementById('qrModalClose');
        const qrModalTitle = document.getElementById('qrModalTitle');
        const qrpackageText = document.getElementById('packageText');
        

        // Toggle Language Function
        function toggleLanguage() {
            currentLanguage = currentLanguage === 'en' ? 'ar' : 'en';
            updateContent();
            updateDirection();
        }

        // Update Content Based on Language
        function updateContent() {
            const t = translations[currentLanguage];
            
            languageToggle.textContent = t.languageToggle;
            brandTitle.textContent = t.brandName;
            brandTagline.textContent = t.tagline;
            whatsappText.textContent = t.whatsapp;
            instagramText.textContent = t.instagram;
            tiktokText.textContent = t.tiktok;
            snapchatText.textContent = t.snapchat;
            facebookText.textContent = t.facebook;
            qrModalTitle.textContent = t.scanQRCode;
            qrpackageText.textContent = t.package;
        }

        // Update Text Direction (RTL/LTR)
        function updateDirection() {
            if (currentLanguage === 'ar') {
                linkTreeContainer.classList.add('rtl');
                linkTreeContainer.classList.remove('ltr');
                document.body.classList.add('rtl');
            } else {
                linkTreeContainer.classList.add('ltr');
                linkTreeContainer.classList.remove('rtl');
                document.body.classList.remove('rtl');
            }
        }

        // Show QR Modal
        function showQRModal() {
            
            qrModal.classList.add('show');
        }

        // Close QR Modal
        function closeQRModal() {
            qrModal.classList.remove('show');
        }

        // Event Listeners
        languageToggle.addEventListener('click', toggleLanguage);
        qrCodeSmall.addEventListener('click', showQRModal);
        qrModalClose.addEventListener('click', closeQRModal);

        // Close modal when clicking outside
        qrModal.addEventListener('click', function(e) {
            if (e.target === qrModal) {
                closeQRModal();
            }
        });

        // Close modal with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && qrModal.classList.contains('show')) {
                closeQRModal();
            }
        });

        // Initialize
        document.addEventListener("DOMContentLoaded", () => {
        updateDirection();
        });
  } catch(e) { console.error(e); }
})();

})();
